import DialogProvider from "@components/dialog_provider"
import TextInput from "@components/text_input"
import { oneTimesUpdate } from "@domain/coupons"
import { yupResolver } from "@hookform/resolvers/yup"
import useControlledForm from "@hooks/use_controlled_form"
import useTranslate from "@hooks/use_translate"
import { Stack } from "@mui/material"
import { ScriptWhatsappFormData } from "@pages/main/scripts"
import { showErrorToast, showSuccessToast } from "@utils/toast"
import { OneTimesType } from "__generated__/graphql"
import { useState } from "react"
import * as yup from "yup"

type AddWhatsappWebToApiDialogProps = {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
}

export default function AddWhatsappWebToApiDialog({
  isOpen,
  setIsOpen
}: AddWhatsappWebToApiDialogProps) {
  const { translate } = useTranslate()
  const [loading, setLoading] = useState(false)

  const schema = yup
    .object({
      channelId: yup.string().required()
    })
    .required()

  const {
    control,
    handleSubmit,
    reset,
    setValue,
    trigger,
    formState: { isValid }
  } = useControlledForm<ScriptWhatsappFormData>({
    resolver: yupResolver(schema),
    mode: "all"
  })

  const setClose = () => {
    setIsOpen(false)
  }

  const handleClose = () => {
    setIsOpen(false)
    reset()
  }

  const onSubmit = async (data: ScriptWhatsappFormData) => {
    setLoading(true)
    const {
      isSuccess,
      errorMessage,
      data: responseData
    } = await oneTimesUpdate({
      type: OneTimesType.ReverseWhatsappWebToBusiness,
      metaData: {
        channelId: data.channelId
      }
    })

    if (!isSuccess || !responseData) {
      setLoading(false)
      showErrorToast(String(errorMessage))
      return
    }

    showSuccessToast(translate("succesfully_added"))
    setLoading(false)
    handleClose()
  }

  return (
    <DialogProvider
      title={"WhatsApp web to api"}
      leftButton={{
        text: translate("cancel"),
        color: "secondary",
        onClick: setClose,
        disabled: loading
      }}
      rightButton={{
        text: translate("create"),
        color: "primary",
        onClick: handleSubmit(onSubmit),
        loading: loading,
        disabled: !isValid
      }}
      isOpen={isOpen}
      setClose={handleClose}
      size="small"
    >
      <Stack gap={1}>
        <TextInput<ScriptWhatsappFormData>
          label={"Channel ID"}
          disabled={loading}
          name="channelId"
          placeholder={translate("enter")}
          control={control}
          onChange={(e) => {
            setValue("channelId", e.target.value)
            trigger("channelId")
          }}
          required
        />
      </Stack>
    </DialogProvider>
  )
}
